import Vue from "vue";
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Los modales no se cierran solos con un clic en el fondo ni con Escape.
//
// Operaciones reportó el caso desde PROD: se copia un dato de otra página, se
// vuelve al portal, un clic en cualquier lado y se pierde el formulario a
// medio llenar. BootstrapVue cierra por las dos vías salvo que se le diga lo
// contrario, y ninguna de las 23 pantallas con modal se lo decía.
//
// Va acá y no como props en cada <b-modal> por lo mismo de siempre: quince
// repeticiones son quince lugares donde olvidarse, y el modal número
// dieciséis nacería con el problema. Una pantalla que de verdad quiera
// cerrarse con un clic afuera puede pedirlo con :no-close-on-backdrop="false".
//
// Verificado contra el código de bootstrap-vue 2.23.1: las dos props son
// configurables globalmente bajo la clave BModal
// (makePropsConfigurable(..., NAME_MODAL), NAME_MODAL = 'BModal').
Vue.use(BootstrapVue, {
  BModal: {
    noCloseOnBackdrop: true,
    noCloseOnEsc: true,
  },
})

